import React from 'react'
import HomeBanner from '../components/HomeComponents/HomeBanner'
import ExploreProperties from "../components/HomeComponents/ExploreProperties"
import AboutSection from '../components/HomeComponents/AboutSection'
import ExploreCategories from '../components/HomeComponents/ExploreCategories'
import WhyChooseKL from '../components/HomeComponents/WhyChoose'
import WhatWeOffer from '../components/HomeComponents/WeOffer'
import MeetFounder from '../components/HomeComponents/MeetFounder'
import VisualGallery from '../components/HomeComponents/VisualGallery'
import Testimonials from '../components/HomeComponents/TestimonialSection'
import Contact from '../components/HomeComponents/ContactSection'

const Home = () => {
  return (
    <div>
      <HomeBanner/>
     <ExploreProperties/>
     <AboutSection/>
     <ExploreCategories/>
     <WhyChooseKL/>
     <WhatWeOffer/>
     <MeetFounder/>
     <VisualGallery/>
     <Testimonials/>
     <Contact/>
     
    </div>
  )
}
export default Home

